import axios from 'axios'

export const TokenExportService = {
    async generateToken(company) {
        return axios.post(`/api/${company}/tokens`)
    },
    async list(company) {
        return axios.get(`/api/${company}/tokens`)
    }
}
